import axios from 'axios'
class CMSAPi {
	url = "https://cms.opsloth.com/cms_service"
	table_name!: string
	data?: object = {}
	filter?: object
	field?: string
	options?: object

	constructor(table_name: string, url= "https://cms.opsloth.com/cms_service") {
		this.table_name = table_name
		this.url = url
	}

	async login(data?: object) {
		try {
			return await axios.post(`${this.url}/login`, data ? data : this.data)
		} catch (e) {
			return e
		}
	}

	async register(data?: object) {
		try {
			return await axios.post(`${this.url}/register`, data ? data : this.data)
		} catch (e) {
			return e
		}
	}

	async get(params?: object) {
		try {
			return await axios.get(`${this.url}/${this.table_name}${this.processParams(params)}`)
		} catch (e) {
			return e
		}
	}
	async count(params?: object) {
		try {
			return await axios.get(`${this.url}/${this.table_name}/count${this.processParams(params)}`)
		} catch (e) {
			return e
		}
	}

	async post(data: object, params?: object) {
		try {
			return await axios.post(`${this.url}/${this.table_name}${this.processParams(params)}`, data ? data : this.data)
		} catch (e) {
			return e
		}
	}

	async put(data: object, params?: object) {
		try {
			return await axios.put(`${this.url}/${this.table_name}${this.processParams(params)}`, data ? data : this.data)
		} catch (e) {
			return e
		}
	}

	private processParams = (params?:{[key: string]: any | string }) => {
		let parmasUrlString = ''
		if (!params){
			params = {}
		}
		params.filter = this.filter ?? {}
		params.field = this.field ?? ''
		params.options = this.options ?? {}
		Object.keys(params).forEach(key => {
			if (typeof(params![key]) === 'string'){  
				parmasUrlString += `&${key}=${encodeURIComponent(params![key].toString())}`
			}else{
				parmasUrlString += `&${key}=${encodeURIComponent(JSON.stringify(params![key]))}`
			}
		})
		parmasUrlString = parmasUrlString.replace('&', '?')
		return parmasUrlString
	}

	setFilter(filter: object) {
		this.filter = filter
		return this
	}

	setField(field: any) {
		this.field = field
		return this
	}

	setOptions(options: object) {
		this.options = options
		return this
	}

}
export default CMSAPi